import React from 'react';
import Widget from '../verticalWidget';

const CategoryWidget10 = (props) => {
  return (
    <div>
      <Widget cardType={9} {...props} />
    </div>
  );
};

export default CategoryWidget10;
